{
  "actionbar.clearSelection": "Clear selection",
  "actionbar.selected": "{count, plural, =0 {None selected} other {# selected}}",
  "actionbar.selectedAll": "All selected",
  "actionbar.actions": "Actions",
  "actionbar.actionsAvailable": "Actions available.",
  "button.pending": "pending",
  "calendar.invalidSelection": "Selected {selectedCount, plural, one {date} other {dates}} unavailable.",
  "contextualhelp.info": "Information",
  "contextualhelp.help": "Help",
  "datepicker.time": "Time",
  "datepicker.startTime": "Start time",
  "datepicker.endTime": "End time",
  "dialog.dismiss": "Dismiss",
  "dialog.alert": "Alert",
  "dropzone.replaceMessage": "Drop file to replace",
  "inlinealert.negative": "Error",
  "inlinealert.notice": "Warning",
  "inlinealert.informative": "Information",
  "inlinealert.positive": "Success",
  "label.(required)": "(required)",
  "label.(optional)": "(optional)",
  "menu.moreActions": "More actions",
  "picker.placeholder": "Select…",
  "slider.minimum": "Minimum",
  "slider.maximum": "Maximum",
  "table.loading": "Loading…",
  "table.loadingMore": "Loading more…",
  "table.sortAscending": "Sort Ascending",
  "table.sortDescending": "Sort Descending",
  "table.resizeColumn": "Resize column",
  "tag.showAllButtonLabel": "Show all ({tagCount, number})",
  "tag.hideButtonLabel": "Show less",
  "tag.actions": "Actions",
  "tag.noTags": "None",
  "combobox.noResults": "No results",
  "notificationbadge.plus": "{notifications}+",
  "notificationbadge.indicatorOnly": "New activity",
  "breadcrumbs.more": "More items",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}